module.exports = "<div>\r\n  <jqxDropDownButton #dropDownTram [auto-create]='true'>\r\n    <jqxTree #treeDienLucTram (onSelect)=\"treeOnSelect($event)\"\r\n             (onExpand)=\"treeOnExpand($event)\"\r\n             [auto-create]='true' [disabled]=\"treeDisabled\">\r\n    </jqxTree>\r\n  </jqxDropDownButton>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/cay-thu-muc/caythumuc.component.html
// module id = ../../../../../src/app/share/cay-thu-muc/caythumuc.component.html
// module chunks = main